/* תפריט הנגישות — התנהגות.
 *
 * ניהול הפוקוס כאן הוא בכוונה אותו ניב של js-cart.js (FOCUSABLE,
 * focusableIn, focusWithoutScroll, זכירת הפותח, inert ולולאת Tab): שתי
 * מלכודות פוקוס שמתנהגות אחרת באותו אתר הן באג בפני עצמן, וקורא מסך
 * לומד את ההתנהגות פעם אחת.
 *
 * ההעדפות עצמן אינן מוחלות כאן אלא ב-jm-a11y-boot, שרץ ב-<head> לפני
 * הצביעה. הקובץ הזה רק משנה אותן ושומר; כך אין הבהוב בטעינה הבאה.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'jm-a11y';

  /* אותה מפה בדיוק כמו ב-jm-a11y-boot. היא משוכפלת ולא משותפת כי הבוט
     חייב להיות inline ב-<head> — קובץ חיצוני היה מגיע אחרי הצביעה. */
  var FLAGS = {
    contrast: 'high',
    grayscale: 'on',
    links: 'on',
    font: 'on',
    motion: 'off',
    cursor: 'big',
    spacing: 'on'
  };

  var TEXT_MIN = 100;
  var TEXT_MAX = 160;
  var TEXT_STEP = 10;

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var root = document.documentElement;
  var state = { text: TEXT_MIN };
  var lastOpener = null;
  var inerted = [];

  function closest(element, selector) {
    var node = element;
    while (node && node.nodeType === 1) {
      if (node.matches && node.matches(selector)) return node;
      node = node.parentElement;
    }
    return null;
  }

  function focusableIn(node) {
    var list = node.querySelectorAll(FOCUSABLE);
    var out = [];
    var i;
    for (i = 0; i < list.length; i += 1) {
      if (closest(list[i], '[inert], [aria-hidden="true"]')) continue;
      if (window.getComputedStyle) {
        var style = window.getComputedStyle(list[i]);
        if (style.display === 'none' || style.visibility === 'hidden') continue;
      }
      if (list[i].getClientRects().length || list[i] === document.activeElement) out.push(list[i]);
    }
    return out;
  }

  function focusWithoutScroll(element) {
    if (!element || !element.isConnected) return;
    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      element.focus();
    }
  }

  function read() {
    var saved = null;
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (raw) saved = JSON.parse(raw);
    } catch (error) {
      /* אחסון חסום או פרופיל שנוקה. ההעדפות עדיין יעבדו בטעינה הזו;
         רק השמירה שלהן אובדת, וזה לא שווה הפלה של האינטראקציה. */
    }
    if (!saved || typeof saved !== 'object') return;

    var text = parseInt(saved.text, 10);
    if (text >= TEXT_MIN && text <= TEXT_MAX) state.text = text;

    for (var key in FLAGS) {
      if (Object.prototype.hasOwnProperty.call(FLAGS, key) && saved[key]) state[key] = true;
    }
  }

  function save() {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (error) {
      /* ראו read: כישלון אחסון לא מפיל את השינוי, רק את זכירתו. */
    }
  }

  function apply() {
    for (var key in FLAGS) {
      if (!Object.prototype.hasOwnProperty.call(FLAGS, key)) continue;
      if (state[key]) {
        root.setAttribute('data-jm-a11y-' + key, FLAGS[key]);
      } else {
        root.removeAttribute('data-jm-a11y-' + key);
      }
    }

    if (state.text > TEXT_MIN) {
      root.setAttribute('data-jm-a11y-text', String(state.text));
      root.style.setProperty('--jm-a11y-scale', String(state.text / 100));
    } else {
      root.removeAttribute('data-jm-a11y-text');
      root.style.removeProperty('--jm-a11y-scale');
    }

    stopCarousels();
  }

  /* עצירת אנימציות ב-CSS לא נוגעת בקרוסלות: Swiper מזיז אותן מ-JS, ולכן
     פקד שעוצר רק CSS היה משאיר את הדבר הזז ביותר בעמוד זז. */
  function stopCarousels() {
    if (!state.motion) return;
    var nodes = document.querySelectorAll('.swiper, .swiper-container');
    for (var i = 0; i < nodes.length; i += 1) {
      var instance = nodes[i].swiper;
      if (!instance || !instance.autoplay) continue;
      try {
        instance.autoplay.stop();
      } catch (error) {
        /* גרסאות Swiper שונות חושפות autoplay אחרת. כישלון כאן משאיר
           קרוסלה אחת בתנועה ואסור לו להפיל את שאר ההעדפות. */
      }
    }
  }

  function init() {
    var widget = document.querySelector('[data-jm-a11y]');
    if (!widget) return;

    var toggle = widget.querySelector('.jm-a11y__toggle');
    var panel = widget.querySelector('.jm-a11y__panel');
    var scrim = widget.querySelector('[data-jm-a11y-scrim]');
    var status = widget.querySelector('[data-jm-a11y-status]');
    var value = widget.querySelector('[data-jm-a11y-value]');
    var options = widget.querySelectorAll('[data-jm-a11y-flag]');
    var steps = widget.querySelectorAll('[data-jm-a11y-step]');
    if (!toggle || !panel) return;

    var strings = { on: 'on', off: 'off', reset_done: '', text_size: '' };
    var holder = widget.querySelector('[data-jm-a11y-strings]');
    if (holder) {
      try {
        strings = JSON.parse(holder.textContent);
      } catch (error) {
        /* אם התרגום לא נפרס, הווידג'ט עדיין עובד — רק ההכרזה הקולית
           תהיה ריקה, וזה עדיף על פקד שלא נפתח. */
      }
    }

    /* ה-JS רץ, ולכן יש למי ללחוץ. */
    toggle.hidden = false;

    function announce(message) {
      if (!status) return;
      status.textContent = message;
    }

    function syncUi() {
      var i;
      for (i = 0; i < options.length; i += 1) {
        var key = options[i].getAttribute('data-jm-a11y-flag');
        options[i].setAttribute('aria-pressed', state[key] ? 'true' : 'false');
      }
      if (value) value.innerHTML = '<bdi dir="ltr">' + state.text + '%</bdi>';
      for (i = 0; i < steps.length; i += 1) {
        var dir = steps[i].getAttribute('data-jm-a11y-step');
        var atEdge = dir === 'up' ? state.text >= TEXT_MAX : state.text <= TEXT_MIN;
        steps[i].disabled = atEdge;
      }
    }

    function setBackgroundInert(on) {
      var i;
      if (on) {
        var children = document.body.children;
        for (i = 0; i < children.length; i += 1) {
          if (children[i] === widget || children[i].hasAttribute('inert')) continue;
          if (children[i].tagName === 'SCRIPT' || children[i].tagName === 'LINK') continue;
          children[i].setAttribute('inert', '');
          inerted.push(children[i]);
        }
        return;
      }
      for (i = 0; i < inerted.length; i += 1) inerted[i].removeAttribute('inert');
      inerted = [];
    }

    function openPanel() {
      if (widget.getAttribute('data-jm-a11y-open') === 'true') return;
      lastOpener = document.activeElement;
      if (scrim) scrim.hidden = false;
      panel.hidden = false;
      panel.removeAttribute('inert');
      widget.setAttribute('data-jm-a11y-open', 'true');
      toggle.setAttribute('aria-expanded', 'true');
      setBackgroundInert(true);
      window.setTimeout(function () { focusWithoutScroll(panel); }, 0);
    }

    function closePanel() {
      if (widget.getAttribute('data-jm-a11y-open') !== 'true') return;
      /* סדר הפעולות כאן נקבע בדיעבד: על מובייל הכפתור מוסתר כל עוד
         הגיליון פתוח, ולכן צריך קודם לסגור — כלומר להחזיר את הכפתור
         לעמוד — ורק אז להעביר אליו את הפוקוס. פוקוס לאלמנט מוסתר פשוט
         נופל ל-<body>, והמשתמש מוצא את עצמו בראש העמוד. */
      setBackgroundInert(false);
      panel.setAttribute('inert', '');
      panel.hidden = true;
      if (scrim) scrim.hidden = true;
      widget.setAttribute('data-jm-a11y-open', 'false');
      toggle.setAttribute('aria-expanded', 'false');
      /* אם הפאנל נפתח בלי שהיה פוקוס אמיתי — לחיצת עכבר או מגע —
         document.activeElement הוא <body>, והחזרת הפוקוס אליו מקפיצה
         את המשתמש לראש העמוד. הכפתור הוא היעד הנכון בכל מקרה כזה. */
      var opener = lastOpener && lastOpener.isConnected && lastOpener !== document.body ? lastOpener : toggle;
      lastOpener = null;
      focusWithoutScroll(opener);
    }

    toggle.addEventListener('click', function () {
      if (widget.getAttribute('data-jm-a11y-open') === 'true') closePanel();
      else openPanel();
    });

    var closeButton = widget.querySelector('[data-jm-a11y-close]');
    if (closeButton) closeButton.addEventListener('click', closePanel);

    /* לחיצה מחוץ לפאנל סוגרת אותו. בלי זה היו בדיוק שתי דרכים לצאת —
       כפתור הסגירה ו-Esc — ובטלפון אין Esc. מכאן שמשתמש נייד שפתח את
       התפריט ולחץ על הרקע קיבל עמוד שלא מגיב (הוא inert) בלי שום רמז
       למה. נרשם על click בשלב ה-capture כדי שיפעל גם מעל אזורים שה-JS
       של הספק עוצר בהם את הבועה. */
    document.addEventListener('click', function (event) {
      if (widget.getAttribute('data-jm-a11y-open') !== 'true') return;
      if (toggle.contains(event.target)) return;
      /* נבדק לפי הקואורדינטות ולא לפי contains, כי הרקע המעומעם הוא
         ::before של הפאנל — כלומר לחיצה עליו מדווחת על הפאנל עצמו
         כ-target, ו-contains היה מחזיר אמת וסוגר לעולם לא. */
      var box = panel.getBoundingClientRect();
      if (event.clientX >= box.left && event.clientX <= box.right &&
          event.clientY >= box.top && event.clientY <= box.bottom) return;
      closePanel();
    }, true);

    for (var o = 0; o < options.length; o += 1) {
      options[o].addEventListener('click', function (event) {
        var button = event.currentTarget;
        var key = button.getAttribute('data-jm-a11y-flag');
        state[key] = !state[key];
        apply();
        save();
        syncUi();
        var label = button.querySelector('span:not(.jm-a11y__dot)');
        announce((label ? label.textContent.trim() : '') + ' — ' + (state[key] ? strings.on : strings.off));
      });
    }

    for (var s = 0; s < steps.length; s += 1) {
      steps[s].addEventListener('click', function (event) {
        var dir = event.currentTarget.getAttribute('data-jm-a11y-step');
        var next = state.text + (dir === 'up' ? TEXT_STEP : -TEXT_STEP);
        if (next < TEXT_MIN || next > TEXT_MAX) return;
        state.text = next;
        apply();
        save();
        syncUi();
        announce(strings.text_size + ' ' + state.text + '%');
        /* אם הכפתור שנלחץ הרגע כובה בגלל הגעה לקצה, הפוקוס היה נופל
           ל-<body> ויוצא מהמלכודת. מעבירים אותו לכפתור הנגדי. */
        if (event.currentTarget.disabled) {
          var other = widget.querySelector('[data-jm-a11y-step="' + (dir === 'up' ? 'down' : 'up') + '"]');
          focusWithoutScroll(other);
        }
      });
    }

    var resetButton = widget.querySelector('[data-jm-a11y-reset]');
    if (resetButton) {
      resetButton.addEventListener('click', function () {
        state = { text: TEXT_MIN };
        apply();
        try {
          window.localStorage.removeItem(STORAGE_KEY);
        } catch (error) {
          /* ראו read. */
        }
        syncUi();
        announce(strings.reset_done);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (widget.getAttribute('data-jm-a11y-open') !== 'true') return;

      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        closePanel();
        return;
      }

      if (event.key !== 'Tab') return;

      var items = focusableIn(panel);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];

      if (!panel.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
        return;
      }
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    read();
    apply();
    syncUi();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
